/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AddCharge/view.blocks to change it.
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function AddCharge({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsCreateClaim/Charges/AddCharge"
  
}) {
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 size="small"
 onClick={onClick}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Add charge"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}